module.exports = "/images/0eec8006b7fcbc6887f419c620bb1b8c.svg";